export class MainNavigation {

    public static getData(): any[] {
        return this.buildArray();
    }

    public static getNodePath(modul: string): any[] {
        const data: any[] = this.buildArray();
        const nodePath: any = [{ name: data[0].name }];

        ((data[0] || {}).children || {}).find((child: any) => child.modul === modul && nodePath.push(child));
        nodePath.push({ name: 'Startseite' });

        return nodePath;
    }

    private static buildArray(): any[] {
        return [
            {
                name: 'E-Tool Module',
                color: 'white',
                bgcolor: '#686868',
                children: [
                    {
                        name: 'E-Tool classic',
                        modul: 'classic',
                    },
                    {
                        name: 'CO₂-Fußabdruck (CFM)',
                        modul: 'cfm',
                    },
                    {
                        name: 'Strom- & Energiesteuer',
                        modul: 'steuer',
                    },
                    {
                        name: 'Nachhaltigkeit',
                        modul: 'nachhaltigkeit',
                    },
                ],
            },
        ];
    }
}
